<template>
  <div class="prediction-basic-from">
    <el-form
      :disabled="readonly"
      class="section"
      style="flex-direction: row;"
      label-width="125px"
    >
      <el-form-item :label="$t('SeaExport.BusinessNo')">
        <el-input v-model="job.jobNo" :disabled="true" no="jobNo" />
      </el-form-item>
      <el-form-item :label="$t('SeaExport.CustomerReferenceNumber')">
        <cargo-input v-model="job.customerRefNo" no="customerRefNo" :trim="true" />
      </el-form-item>
      <el-form-item :label="$t('SeaExport.ItemNo')" :class="poNoRed?'poNoClass':''">
        <cargo-input v-model="job.poNo" no="poNo" />
      </el-form-item>
      <el-form-item :label="$t('SeaExport.InputDate2')">
        <el-date-picker v-model="inputDate" type="date" no="inputDate" value-format="yyyy-MM-dd" :disabled="true" style="width: 175px;" />
      </el-form-item>
    </el-form>
    <el-form ref="basicForm" :disabled="readonly" style="display: flex;height: 100%;" label-position="right" :label-width="isZh ? '135px' : '160px'">
      <div style="width: fit-content;display: flex;height: fit-content">
        <div class="section form-column" style="min-height: 635px;width: 349px">
          <template v-if="isZY">
            <el-form-item>
              <span slot="label" class="blue">{{ $t('SeaExport.AllowSaleProduct') }}</span>
              <cargo-advance-select
                :select-type="selectTypeNames.basic_data_AllowSaleProduct"
                filterable
                no="allowSaleProduct"
                clearable
                :data-filter-function="p => p.statusEnabled && p.seaImportEnabled"
                :default-value="job.saleProductCode || ''"
                @parentCallBack="p => {job.saleProductCode = p.value}"
              />
            </el-form-item>
            <el-form-item>
              <span slot="label" class="blue">{{ $t('SeaExport.FullOrInside') }}</span>
              <cargo-advance-select
                :select-type="selectTypeNames.local_cache_FullOrInside$FULL_OR_INSIDE"
                no="fullOrInside"
                clearable
                :default-value="job.fullOrInside || ''"
                @parentCallBack="p => {job.fullOrInside = p.value}"
              />
            </el-form-item>
          </template>
          <el-form-item :label="$t('SeaExport.SolicitationType')">
            <el-select
              v-model="job.cargoSource"
              :disabled="isCrossTenantSEToSI"
              no="cargoSource"
              :placeholder="$t('SeaExport.PleaseSelect')"
              @change="p=>{pm.cargoSourceChange(p)}"
            >
              <el-option
                v-for="(item,index) in CARGO_SOURCES"
                :key="index"
                :label="$store.getters.language==='zh'?item.chineseName:item.englishName"
                :value="item.code"
              />
            </el-select>&nbsp;
          </el-form-item>
          <el-form-item :label="$t('SeaExport.CustomJobType')">
            <cargo-advance-select
              no="customJobType"
              filterable
              :select-type="selectTypeNames.basic_data_CutomJobType"
              :method-params="{type:'SI', active: true}"
              callback-method-type="value"
              :default-value="job.customJobType"
              :callback-params="{key:'customJobType'}"
              @parentCallBack="val=>{job.customJobType = val.value;onCustomJobTypeChange()}"
            />
          </el-form-item>
          <el-form-item v-show="visibleDesignationAgent" class="required" :label="$t('SeaExport.NominatedAgent')">
            <cargo-company-select
              ref="designationAgent"
              no="designationAgent"
              :method-params="{designationAgent:true,active:true}"
              :default-value="job.designationAgent||''"
              style="width: 100%"
              @change="p=>{pm.designationAgentChange(p)}"
            />
          </el-form-item>
          <el-form-item v-show="visibleDesignationAgent" :label="$t('SeaExport.PortOfLoadingAgent')">
            <cargo-advance-select
              no="destinationAgent"
              filterable
              :select-type="selectTypeNames.basic_data_Company"
              :method-params="{overseaAgent:true,active:true}"
              :default-value="job.destinationAgent||''"
              style="width: 100%"
              @parentCallBack="p=>{pm.txtDestinationAgentChangeHandler(p)}"
            />
          </el-form-item>
          <el-form-item :label="visibleDesignationAgent ? $t('SeaExport.ActualNotifyParty') : $t('SeaExport.ConsignationCompany')" class="required">
            <cargo-sales-company-select
              no="customerId"
              :method-params="{customer:true, active: true,companyLob:'seaImport'}"
              :default-value="job.customerId||''"
              @parentCallBack="p=>{pm.customerIdChange(p)}"
            />
          </el-form-item>
          <el-form-item :label="$t('SeaExport.ContactPerson')">
            <el-select
              v-model="job.customerContact"
              no="customerContact"
              filterable
              :allow-create="true"
              @change="pm.customerContactChange()"
            >
              <el-option
                v-for="(item,index) in contactList"
                :key="index"
                :label="item.contactPerson"
                :value="item.contactPerson"
              />
            </el-select>
          </el-form-item>
          <el-form-item v-show="!isShowContactPersonDetail" :label="$t('SeaExport.Tel')">
            <el-input v-model="job.contactTelephone" no="contactTelephone" />
          </el-form-item>
          <el-form-item v-show="!isShowContactPersonDetail" :label="$t('SeaExport.Fax')">
            <el-input v-model="job.contactFax" no="contactFax" />
          </el-form-item>
          <el-form-item v-show="!visibleDesignationAgent" :label="$t('SeaExport.PortOfLoadingAgent')">
            <cargo-advance-select
              no="destinationAgent"
              filterable
              :select-type="selectTypeNames.basic_data_Company"
              :method-params="{overseaAgent:true,active:true}"
              :default-value="job.destinationAgent||''"
              :disabled="isCrossTenantSEToSI"
              style="width: 100%"
              @parentCallBack="p=>{pm.txtDestinationAgentChangeHandler(p)}"
            />
          </el-form-item>
          <el-form-item v-if="isCrossTenantSEToSI" :label="$t('SeaExport.ConsignationRelationNumber')">
            <el-input no="trustFromJob" :value="job.trustFromJob" :disabled="true" />
          </el-form-item>
          <el-form-item :label="$t('SeaExport.ShippingCompany')">
            <cargo-company-select
              no="carrierId"
              :method-params="{companyLob:'seaImport',seaCmp:true,active:true}"
              :default-value="job.carrierId||''"
              @change="p=>{job.carrierId=p.value;onCarrierIdChange()}"
            />
          </el-form-item>
          <el-form-item :label="$t('SeaExport.Mbl2')">
            <cargo-input v-model="job.mbl" :auto-uppercase="true" :disabled="isCrossTenantSEToSI" no="mbl" />
          </el-form-item>
          <el-form-item :label="$t('SeaExport.Hbl2')">
            <cargo-input v-model="job.hbl" :auto-uppercase="true" :disabled="isCrossTenantSEToSI" no="hbl" @change="pm.hblFunction($event)" />
          </el-form-item>
          <el-form-item :label="$t('SeaExport.Vessel')">
            <cargo-input v-model="job.vessel" :auto-uppercase="true" :disabled="isCrossTenantSEToSI" no="vessel" />
          </el-form-item>
          <el-form-item :label="$t('SeaExport.Voyage')">
            <cargo-input v-model="job.voyageFlight" :auto-uppercase="true" :disabled="isCrossTenantSEToSI" no="voyageFlight" @focus="loadVoyageFlight" />
          </el-form-item>
          <el-form-item :label="$t('SeaExport.PlaceOfReceipt')">
            <cargo-input v-model="job.dispatchingPlace" :auto-uppercase="true" no="dispatchingPlace" />
          </el-form-item>
          <el-form-item :label="$t('SeaExport.PortOfLoading')" class="required">
            <cargo-advance-select
              no="loadingPortCode"
              filterable
              :select-type="selectTypeNames.basic_data_Seaport"
              :default-value="job.loadingPortCode"
              :disabled="isCrossTenantSEToSI"
              @parentCallBack="p=>{pm.loadingPortCodeChange(p)}"
            />
          </el-form-item>
          <el-form-item :label="$t('SeaExport.PortOfDischarge')" class="required">
            <cargo-advance-select
              no="dischargingPortCode"
              filterable
              :select-type="selectTypeNames.basic_data_Seaport"
              :default-value="job.dischargingPortCode"
              :disabled="isCrossTenantSEToSI"
              @parentCallBack="p=>{
                pm.job.dischargingPortCode = p.value
                pm.dischargingPortCodeChange(p)
              }"
            />
          </el-form-item>
          <el-form-item :label="$t('SeaExport.PlaceOfDelivery')" class="required">
            <cargo-advance-select
              no="destinationPortCode"
              :disabled="readonly"
              :select-type="selectTypeNames.basic_data_Seaport"
              filterable
              :default-value="job.destinationPortCode"
              @parentCallBack="p=>{job.destinationPortCode=p.value;pm.destinationPortCodeEasyChange(p)}"
            />
          </el-form-item>
          <el-form-item :label="$t('SeaExport.FinalDestination')">
            <el-input v-model="job.destinationPlace" :disabled="isCrossTenantSEToSI" no="destinationPlace" />
          </el-form-item>
          <el-form-item :label="$t('SeaExport.CustomsDeclarationWay')">
            <cargo-advance-select
              no="customClaim"
              filterable
              :disabled="readonly"
              :select-type="selectTypeNames.local_cache_AirExportConstants$CUSTOM_CLAIMS"
              :default-value="job.customClaim===-1?'':job.customClaim"
              :tag-name="isZh?'chineseName':'englishName'"
              tag-value="code"
              :zero-can-copy="true"
              :fields="[isZh?'chineseName':'englishName']"
              @parentCallBack="p=>{job.customClaim=p.value}"
            />
          </el-form-item>
          <el-form-item v-if="job.customClaim===1" :label="$t('SeaExport.CustomsDeclarationType')">
            <cargo-advance-select
              no="customsDeclarationType"
              :disabled="readonly"
              :select-type="selectTypeNames.basic_data_CustomsDeclarationType"
              filterable
              :default-value="job.customsDeclarationType===-1?'':job.customsDeclarationType"
              :placeholder="$t('CargoMsg.Cargo_keyWordsTip')"
              @parentCallBack="p=>{job.customsDeclarationType=p.value}"
            />
          </el-form-item>
          <el-form-item :label="$t('Message.TerminalCompany')">
            <cargo-company-select
              no="terminalCompany"
              :disabled="readonly"
              :method-params="{terminalCompany:true,companyLob:'seaImport',active:true}"
              :default-value="job.terminalCompany||''"
              style="width: 100%"
              @change="p=>{JobUtils.terminalCompanyChangeHandler(job, p)}"
            />
          </el-form-item>
          <el-form-item :label="$t('Message.DeliveryAddress')">
            <cargo-rich-textarea
              v-model="job.deliveryAddress"
              no="deliveryAddress"
              :disabled="readonly"
              style="height: 110px;"
              @dblclick.native="showAdvanceTextDialog($t('Message.DeliveryAddress'),job.deliveryAddress,val=>{job.deliveryAddress=val})"
            />
          </el-form-item>
        </div>
        <div class="section form-column" style="min-height: 635px">
          <el-form-item :label="$t('SeaExport.DateOfDeparture')">
            <el-date-picker
              v-model="job.etd"
              no="etd"
              type="date"
              clearable
              style="width: 100%;"
              :disabled="isCrossTenantSEToSI"
              value-format="yyyy-MM-dd"
            />
          </el-form-item>
          <el-form-item :label="$t('SeaExport.ExpectedArrivalDate')">
            <el-date-picker
              v-model="job.eta"
              no="eta"
              type="date"
              clearable
              style="width: 100%;"
              value-format="yyyy-MM-dd"
            />
          </el-form-item>
          <el-form-item :label="$t('SeaExport.ActualDateOfArrival')">
            <el-date-picker
              v-model="job.ata"
              no="ata"
              type="date"
              clearable
              style="width: 100%;"
              value-format="yyyy-MM-dd"
            />
          </el-form-item>
          <el-form-item :label="$t('SeaExport.ArrivalTime2')">
            <el-date-picker
              v-model="job.arrivalTime"
              no="arrivalTime"
              :disabled="readonly"
              type="date"
              value-format="yyyy-MM-dd"
              style="width: 100%"
            />
          </el-form-item>
          <el-form-item label="">
            <div style="display: flex;justify-content: flex-end">
              <el-button type="primary" :disabled="readonly" no="otherBill" @click="onExcerption">{{ $t('SeaExport.CopyFromOtherBill') }}</el-button>
              <el-button type="primary" :disabled="readonly" no="codeSearching" @click="onCodeSearch">{{ $t('SeaExport.CodeSearching') }}</el-button>
            </div>
          </el-form-item>
          <el-form-item :label="$t('SeaExport.Shipper')">
            <div style="display: flex;justify-content: space-between">
              <cargo-input v-model="job.shipperCode" style="width:80px;margin-right: 5px" :disabled="readonly || isCrossTenantSEToSI" no="shipperCode" :placeholder="readonly ? '' : $t('SeaExport.Code2')" :auto-uppercase="notUppercaseShipperConsigneNotify" />
              <cargo-input
                v-model="job.shipperLine1"
                no="shipperLine1"
                :disabled="readonly || isCrossTenantSEToSI"
                :auto-uppercase="notUppercaseShipperConsigneNotify"
                :placeholder="readonly ? '' : $t('SeaExport.BillsOfLadingDoubleClickEject')"
                @dblclick.native="showSenderAndReceiverDialog('shipper',6, false, notUppercaseShipperConsigneNotify)"
              />
            </div>
          </el-form-item>
          <el-form-item :label="$t('SeaExport.Consignee')">
            <div style="display: flex;justify-content: space-between">
              <cargo-input
                v-model="job.consigneeCode"
                no="consigneeCode"
                style="width:80px;margin-right: 5px"
                :disabled="readonly || isCrossTenantSEToSI"
                :placeholder="readonly ? '' : $t('SeaExport.Code2')"
                :auto-uppercase="notUppercaseShipperConsigneNotify"
                @change="pm.qConsigneeCode_focusOutHandler()"
              />
              <cargo-input
                v-model="job.consigneeLine1"
                :disabled="readonly || isCrossTenantSEToSI"
                no="consigneeLine1"
                :auto-uppercase="notUppercaseShipperConsigneNotify"
                :placeholder="readonly ? '' : $t('SeaExport.BillsOfLadingDoubleClickEject')"
                @dblclick.native="showSenderAndReceiverDialog('consignee',6, false, notUppercaseShipperConsigneNotify)"
                @change="pm.qConsigneeAddr_focusOutHandler()"
              />
            </div>
          </el-form-item>
          <el-form-item :label="$t('SeaExport.NotifyParty')">
            <div style="display: flex;justify-content: space-between">
              <cargo-input v-model="job.notifyCode" style="width:80px;margin-right: 5px" :disabled="readonly || isCrossTenantSEToSI" no="notifyCode" :placeholder="readonly ? '' : $t('SeaExport.Code2')" :auto-uppercase="notUppercaseShipperConsigneNotify" />
              <cargo-input
                v-model="job.notifyLine1"
                no="notifyLine1"
                :disabled="readonly || isCrossTenantSEToSI"
                :auto-uppercase="notUppercaseShipperConsigneNotify"
                :placeholder="readonly ? '' : $t('SeaExport.BillsOfLadingDoubleClickEject')"
                @dblclick.native="showSenderAndReceiverDialog('notify',6,false, notUppercaseShipperConsigneNotify)"
              />
            </div>
          </el-form-item>
          <el-form-item :label="$t('SeaExport.ActualQuantity')">
            <auto-number-input
              v-model="job.quantityActual"
              no="quantityContract"
              :precision="0"
              :min="0"
              :disabled="readonly || isCrossTenantSEToSI"
              @change="pm.quantityChange()"
            />
          </el-form-item>
          <el-form-item :label="$t('SeaExport.Package')">
            <cargo-packing-select
              :disabled="readonly || isCrossTenantSEToSI"
              no="packing"
              :default-value="job.packing"
              @change="p=>{job.packing=p.value;pm.chargePacking()}"
            />
          </el-form-item>
          <el-form-item :label="$t('SeaExport.ActualWeight')">
            <div style="display: flex">
              <auto-number-input
                v-model="job.weightActual"
                no="weightContract"
                :precision="3"
                :min="0"
                :disabled="readonly || isCrossTenantSEToSI"
                @change="pm.weightChange()"
              />
              <span>KGS</span>
            </div>
          </el-form-item>

          <el-form-item :label="$t('SeaExport.ActualVolume')">
            <div style="display: flex">
              <auto-number-input
                v-model="job.cubageActual"
                no="cubageContract"
                :precision="3"
                :min="0"
                :disabled="readonly || isCrossTenantSEToSI"
                @change="pm.cubageChange()"
              />
              <span>CBM</span>
            </div>
          </el-form-item>
          <el-form-item :label="$t('SeaExport.ChargedWeight')">
            <auto-number-input
              v-model="job.chargeWeight"
              no="chargeWeight"
              :precision="3"
              :min="0"
              :disabled="isCrossTenantSEToSI"
              @change="pm.chargeWeightChangeHandler()"
            />
          </el-form-item>
          <el-form-item :label="$t('SeaExport.ChineseDescriptionOfGoods')">
            <cargo-rich-textarea
              v-model="job.cargoChineseName"
              no="cargoChineseName"
              :text-chars="0"
              :warning-count="45"
              :auto-uppercase="true"
              style="height: 110px"
              :disabled="readonly"
              @dblclick.native="showAdvanceTextDialog($t('SeaExport.ChineseDescriptionOfGoods'),job.cargoChineseName,val=>{job.cargoChineseName=val}, false,{warningCount:45,maxChar: 0})"
            />
          </el-form-item>
          <el-form-item :label="$t('SeaExport.EnglishDescriptionOfGoods')">
            <cargo-rich-textarea
              v-model="job.cargoEnglishName"
              no="cargoEnglishName"
              :text-chars="0"
              :warning-count="45"
              :auto-uppercase="isUppercaseByConfig"
              style="height: 110px"
              :disabled="readonly || isCrossTenantSEToSI"
              @dblclick.native="showAdvanceTextDialog($t('SeaExport.EnglishDescriptionOfGoods'),job.cargoEnglishName,val=>{job.cargoEnglishName=val}, false,{warningCount:45,maxChar: 0},isUppercaseByConfig)"
            />
          </el-form-item>
          <el-form-item :label="$t('SeaExport.TradeTerms')">
            <cargo-advance-select
              filterable
              :disabled="readonly||isCrossTenantSEToSI"
              no="incoTerm"
              :select-type="selectTypeNames.basic_data_IncoTerm"
              :method-params="{}"
              callback-method-type="value"
              :default-value="job.incoTerm+''"
              :callback-params="{key:'incoTerm'}"
              @parentCallBack="setJobSelectValue"
            />
          </el-form-item>
        </div>
        <div class="section form-column" style="min-height: 635px">
          <el-form-item :label="$t('SeaExport.MblNo4')">
            <el-input v-model="job.masterJobNo" :disabled="true" no="masterJobNo" />
          </el-form-item>
          <el-form-item :label="$t('SeaExport.FLCLType')">
            <cargo-advance-select
              no="containerLoadType"
              filterable
              :clearable="false"
              :disabled="isCrossTenantSEToSI"
              :select-type="selectTypeNames.local_cache_ImportConstants$_cargoTypeInputList"
              :default-value="job.containerLoadType"
              :tag-name="$store.getters.language==='zh'?'chineseName':'englishName'"
              @parentCallBack="p=>{pm.cargoTypeChange(p)}"
            />
          </el-form-item>
          <el-form-item :label="$t('SeaExport.TransportationClause')">
            <cargo-advance-select
              no="freightTermHBL"
              filterable
              :clearable="false"
              :disabled="isCrossTenantSEToSI"
              :select-type="selectTypeNames.basic_data_ShippingTerm"
              :default-value="job.freightTermHBL"
              @parentCallBack="p=>{job.freightTermHBL=p.value}"
            />
          </el-form-item>
          <el-form-item :label="$t('SeaExport.CargoType')">
            <cargo-advance-select
              no="cargoType"
              filterable
              :clearable="false"
              :select-type="selectTypeNames.basic_data_CargoType"
              :default-value="job.cargoType"
              @parentCallBack="p=>{job.cargoType=p.value;onCargoTypeChagne()}"
            />
          </el-form-item>
          <el-form-item :label="$t('SeaExport.HBLFreightClause')">
            <cargo-advance-select
              no="paymentTermHBL"
              filterable
              :clearable="false"
              :disabled="isCrossTenantSEToSI"
              :select-type="selectTypeNames.basic_data_PaymentTerm"
              :default-value="job.paymentTermHBL"
              :callback-params="{key:'paymentTermHBL'}"
              @parentCallBack="p=>{job.paymentTermHBL=p.value}"
            />
          </el-form-item>
          <el-form-item :label="$t('SeaExport.MasterBLFreightTerm')">
            <cargo-advance-select
              no="paymentTermMBL"
              filterable
              :clearable="false"
              :disabled="isCrossTenantSEToSI"
              :select-type="selectTypeNames.basic_data_PaymentTerm"
              :default-value="job.paymentTermMBL"
              @parentCallBack="p=>{job.paymentTermMBL=p.value}"
            /></el-form-item>
          <el-form-item :label="$t('SeaExport.HblCargoReleaseWay')">
            <cargo-advance-select
              :disabled="readonly"
              no="releaseTypeHbl"
              :clearable="false"
              :select-type="selectTypeNames.local_cache_ImportConstants$_importReleaseTypes"
              callback-method-type="value"
              :default-value="job.releaseTypeHbl"
              :headers="[$t('Tool.Code')]"
              :fields="['code']"
              :tag-name="$store.getters.language==='zh'?'chineseName':'englishName'"
              tag-value="code"
              :callback-params="{key:'releaseTypeHBL'}"
              @parentCallBack="val=>{job.releaseTypeHbl=val.value}"
            />
          </el-form-item>
          <el-form-item :label="$t('SeaExport.HarborDistrict')">
            <cargo-input v-model="job.portDistrict" :auto-uppercase="true" no="portDistrict" />
          </el-form-item>
          <el-form-item
            v-show="job.containerLoadType!=='LCL'"
            label-width="0"
            class="auto-width"
          >
            <booking-sea-eq-data-grid
              :value="seaEqList"
              :is-edit="isEdit"
              :job="job"
            />
          </el-form-item>
          <el-form-item :label="$t('SeaExport.Remarks')">
            <cargo-rich-textarea
              v-model="job.remarks"
              no="remarks"
              style="height: 110px;"
              :disabled="readonly"
              :is-trim="true"
              @dblclick.native="showAdvanceTextDialog($t('SeaExport.Remarks'),job.remarks,val=>{job.remarks=val})"
            />
          </el-form-item>
        </div>
        <div class="section form-column" style="min-height: 635px">
          <el-form-item :label="$t('SeaExport.SalesCompany')">
            <el-input v-model="txtSalesOffice" :disabled="true" no="txtSalesOffice" />
          </el-form-item>
          <el-form-item>
            <span slot="label" class="blue">{{ $t('SeaExport.Sales') }}</span>
            <cargo-user-select
              ref="sales"
              no="sales"
              :method-params="{officeId:salesOfficeCheck?$store.getters.currentOfficeId:'',category:'role',shape:'sales'}"
              :default-value="job.sales||''"
              :static-options="salesList"
              :placeholder="salesPrompt"
              style="width:200px;"
              @change="p=>{pm.salesChangeHandler(p)}"
            />&nbsp;
          </el-form-item>
          <el-form-item :label="$t('SeaExport.SalesOfGoods')">
            <cargo-user-select
              no="cargoSalesId"
              :method-params="{category:'role',shape:'salesOfGoods'}"
              :default-value="job.cargoSalesId||''"
              :static-options="cargoSalesList"
              @change="p=>{job.cargoSalesId=p.value;pm.cargoSalesChargeHandler(p)}"
            />
          </el-form-item>
          <el-form-item :label="$t('SeaExport.SalesDepartment')">
            <cargo-department-new-select
              :disabled="!job.sales"
              no="salesOffice"
              :sales-id="Number(job.sales)"
              :enables="true"
              :office-id="job.salesOffice"
              :department-id="Number(job.salesDepartment)"
              @change="p=>{pm.salesDepartmentChange(p)}"
            />
          </el-form-item>
          <el-form-item :label="$t('SeaExport.OperationCompany')">
            <cargo-advance-select
              :disabled="readonly || opOfficeDisabled"
              no="opOffice"
              :static-options="cacheOffices"
              :select-type="selectTypeNames.basic_data_Office"
              filterable
              :default-value="job.opOffice"
              @parentCallBack="p=>{job.opOffice=p.value;job.opDepartment=0;opOfficeChargeHandler()}"
            />
          </el-form-item>
          <el-form-item :label="$t('SeaExport.OperationDepartment')" class="required">
            <cargo-department-select
              ref="department"
              no="opDepartment"
              :office-id="Number(job.opOffice)"
              :enables="true"
              :department-id="Number(job.opDepartment)"
              @change="p=>{job.opDepartment=p.value}"
            />
          </el-form-item>
          <el-form-item :label="$t('SeaExport.Operation')">
            <cargo-user-select
              no="op"
              :method-params="{officeId:job.opOffice,category:'role',shape:'siop'}"
              :default-value="job.op||''"
              :static-options="userPortRoleData.op"
              @change="p=>{pm.opChange(p)}"
            />
          </el-form-item>
          <el-form-item :label="$t('SeaExport.CustomerOffice')">
            <cargo-office-select
              no="csrOffice"
              :disabled="true"
              :office-id="Number(job.csrOffice)"
              @change="p=>{job.csrOffice=p.value;job.csrDepartment=0}"
            />
          </el-form-item>
          <el-form-item>
            <span slot="label">{{ $t('Message.Customer_Service') }}</span>
            <cargo-department-select
              no="csrDepartment"
              :office-id="Number(job.csrOffice)"
              :disabled="readonly"
              :enables="true"
              :department-id="Number(job.csrDepartment)"
              @change="p=>{job.csrDepartment=p.value}"
            />
          </el-form-item>
          <el-form-item :label="$t('SeaExport.CustomerService')">
            <cargo-user-select
              no="csr"
              :method-params="{category:'role',shape:'csr',officeId: job.salesOffice ? (job.salesOffice === 1?job.opOffice:job.salesOffice) : null}"
              :default-value="job.csr||''"
              :static-options="userPortRoleData.csr"
              @change="p=>{pm.csrChange(p)}"
            />
          </el-form-item>
          <el-form-item :label="$t('SeaExport.DocumentOffice')">
            <cargo-office-select
              no="dcOffice"
              :disabled="true"
              :office-id="Number(job.dcOffice)"
              @change="p=>{job.dcOffice=p.value;job.dcDepartment=0}"
            />
          </el-form-item>
          <el-form-item>
            <span slot="label">{{ $t('Message.Documentation_Department') }}</span>
            <cargo-department-select
              no="dcDepartment"
              :office-id="Number(job.dcOffice)"
              :disabled="readonly"
              :enables="true"
              :department-id="Number(job.dcDepartment)"
              @change="p=>{job.dcDepartment=p.value}"
            />
          </el-form-item>
          <el-form-item :label="$t('SeaExport.Documents')">
            <cargo-user-select
              no="dc"
              :method-params="{category:'role',shape:'doc',officeId:job.opOffice}"
              :default-value="job.dc||''"
              :static-options="userPortRoleData.doc"
              @change="p=>{pm.dcChange(p)}"
            />
          </el-form-item>
          <el-form-item :label="$t('SeaExport.AirlineOffice')">
            <cargo-office-select
              no="plannerOffice"
              :disabled="true"
              :office-id="Number(job.plannerOffice)"
              @change="p=>{job.plannerOffice=p.value;job.plannerDepartment=0}"
            />
          </el-form-item>
          <el-form-item>
            <span slot="label">{{ $t('SeaExport.AirlineDepartment') }}</span>
            <cargo-department-select
              no="plannerDepartment"
              :office-id="Number(job.plannerOffice)"
              :disabled="readonly"
              :enables="true"
              :department-id="Number(job.plannerDepartment)"
              @change="p=>{job.plannerDepartment=p.value}"
            />
          </el-form-item>
          <el-form-item :label="$t('SeaExport.AirlinePerson')">
            <cargo-user-select
              no="planner"
              :method-params="{category:'role',shape:'sealine',officeId:job.opOffice}"
              :default-value="job.planner||''"
              :static-options="userPortRoleData.seaLine"
              @change="p=>{pm.plannerChange(p)}"
            />
          </el-form-item>
          <el-form-item :label="$t('SeaExport.FieldOperation')">
            <cargo-user-select
              no="siteOP"
              :method-params="{officeId:job.opOffice,category:'role',shape:'siteOp'}"
              :default-value="job.siteOP||''"
              :static-options="userPortRoleData.siteOp"
              @change="p=>{JobUtils.siteOpChangeHandler(job, p)}"
            />
          </el-form-item>
          <el-form-item :label="$t('SeaExport.OverseaCustomerService')">
            <cargo-user-select
              ref="overseaOp"
              no="overseaOp"
              class="input2"
              :default-value="job.overseaOp||''"
              :method-params="{category:'role',shape:'overseaOp'}"
              :static-options="isHC ? null : (userPortRoleData.overseaOp || overseaAgentUsersList)"
              :merge-load="true"
              @change="p=>{
                job.overseaOp = p.value
                OverseaCustomerUtils.overseaOpChangeHandler(view, p)
              }"
            />
          </el-form-item>
          <el-form-item :label="$t('SeaExport.TaxNature')">
            <el-select
              v-model="job.taxNature"
              no="taxNature"
              :placeholder="$t('SeaExport.PleaseSelect')"
              size="mini"
            >
              <el-option
                v-for="(item,index) in TAX_NATURES"
                :key="index"
                :label="isZh?item.chineseName:item.englishName"
                :value="item.code"
              />
            </el-select>&nbsp;
          </el-form-item>
        </div>
      </div>
    </el-form>

    <!-- 单号抄录 -->
    <import-prompt-title-dialog
      :visible.sync="importPromptTitleDialog.visible"
      :lob="job.lob"
      @selected="onExcerptionChangeFunc"
    />
    <!--  代码检索-->
    <import-bill-address-title-dialog :visible.sync="billAddressDialog.visible" :job="job" @callback="codeSearchCallback" />

    <!-- 高级文本弹框 -->
    <el-dialog
      v-el-drag-dialog
      :visible.sync="advanceTextDialog.visible"
      :title="advanceTextDialog.title"
      width="600px"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
    ><cargo-rich-textarea
       v-model="advanceTextDialog.value"
       :disabled="readonly"
       :text-chars="advanceTextDialog.formatObj.maxChar"
       :auto-uppercase="advanceTextDialog.isUppercase"
       :warning-count="advanceTextDialog.formatObj.warningCount"
       style="height: 198px;"
     />
      <span slot="footer">
        <el-button v-show="advanceTextDialog.visible" type="primary" no="confirm" @click="finishAdvanceText">{{ $t('common.btn.confirm') }}</el-button>
        <el-button
          no="close"
          @click="advanceTextDialog.visible=false"
        >{{ $t('common.btn.close') }}</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { TYPE_NAMES } from '@/utils/class/AdvanceSelect'
import { SeaImportJob } from '@/class/model/booking/SeaImportJob'
import { CARGO_SOURCES, TAX_NATURES } from '@/class/cargo/model/parameters/SystemConstants'
import { BasicTabHP } from '@/views/cargo/v0/SeaImport/components/Prediction/basicTabHP'
import cargoAdvanceSelect from '@/components/Cargo/Common/cargoAdvanceSelect'
import cargoDepartmentNewSelect from '@/components/Cargo/Common/cargoDepartmentNewSelect'
import cargoDepartmentSelect from '@/components/Cargo/Common/cargoDepartmentSelect'
import cargoUserSelect from '@/components/Cargo/Common/cargoUserSelect'
import cargoCompanySelect from '@/components/Cargo/Common/cargoCompanySelect'
import cargoProjectSelect from '@/components/Cargo/Common/cargoProjectSelect'
import cargoPackingSelect from '@/components/Cargo/Common/cargoPackingSelect'
import cargoInput from '@/components/Cargo/Common/cargoInput'
import SenderAndReceiver from '@/mixin/SenderAndReceiver'
import bookingSeaEqDataGrid from '@/views/cargo/v0/SeaImport/components/Prediction/bookingSeaEqDataGrid'
import cargoRichTextarea from '@/components/Cargo/Common/cargoRichTextarea'
import ImportPromptTitleDialog from '@/components/Cargo/Job/importPromptTitleDialog'
import ImportBillAddressTitleDialog from '@/components/Cargo/Job/importBillAddressTitleDialog'
import AutoNumberInput from '@/components/Cargo/Common/AutoNumberInput'
import { ContainerUtil } from '@/class/cargo/model/utils/ContainerUtil'
import { JobUtils } from '@/class/cargo/model/utils/JobUtils'
import { OverseaCustomerUtils } from '@/class/cargo/model/utils/OverseaCustomerUtils'
import CargoSalesCompanySelect from '@/components/Cargo/Common/cargoSalesCompanySelect'
import { checkPoNoIsExist } from '@/api/booking/job'
import { getBranchByLevel } from '@/utils/basicDataCache'
import cargoOfficeSelect from '@/components/Cargo/Common/cargoOfficeSelect.vue'
import BasicTabMixin from '@/mixin/BasicTabMixin'
import { cache, cacheName } from '@/utils/cacheManager'

export default {
  name: 'PredictionBasicTab',
  components: {
    cargoOfficeSelect,
    cargoAdvanceSelect,
    cargoDepartmentNewSelect,
    cargoDepartmentSelect,
    cargoCompanySelect,
    cargoUserSelect,
    cargoProjectSelect,
    cargoPackingSelect,
    cargoInput,
    bookingSeaEqDataGrid,
    ImportPromptTitleDialog,
    ImportBillAddressTitleDialog,
    cargoRichTextarea,
    AutoNumberInput,
    CargoSalesCompanySelect
  },
  mixins: [SenderAndReceiver, BasicTabMixin],
  props: {
    context: {
      type: Object,
      required: true
    },
    action: {
      type: String,
      required: true
    },
    viewSource: { // 页面请求发起方
      type: String,
      required: false
    },
    isCrossTenantSEToSI: { // 是否跨租户出口转进口
      type: Boolean,
      required: false
    },
    cooperateEdit: { // 能否修改
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      inputDate: new Date(),
      loading: false,
      pm: new BasicTabHP(this),
      selectTypeNames: TYPE_NAMES,
      TAX_NATURES,
      job: new SeaImportJob().fillDefaultValue().getData(),
      CARGO_SOURCES,
      contactList: [], // 联系人下拉框数据源
      salesList: [], // 销售下拉框数据源
      salesPrompt: '', // 销售浮动提示
      txtSalesOffice: '', // 销售分公司
      lclMasterFlag: false, // 是否是小票
      salesOfficeCheck: false, // 是否按照分公司控制 (1:开启分公司过滤 0:关闭分公司过滤),
      branchOfficeCheck: false,
      billAddressDialog: {
        visible: false,
        params: null,
        job: null
      },
      importPromptTitleDialog: {
        visible: false
      },
      seaEqList: [], // 箱子数据源
      JobUtils,
      overseaAgentUsersList: [], // 海外客服用户列表
      OverseaCustomerUtils,
      view: this,
      isZh: this.$store.getters.language === 'zh',
      poNoRed: false,
      needConfirmProjectNo: false,
      userPortRoleData: {
        userDefinedRole1: null,
        userDefinedRole2: null,
        overseaOp: null,
        siteOp: null,
        doc: null,
        csr: null,
        op: null,
        seaLine: null,
        airline: null,
        railwayLine: null
      },
      cargoSalesList: null,
      isZY: false, // 显示中邮选项
      isHC: false,
      isShowContactPersonDetail: false, // 海创显示详细信息
      notUppercaseShipperConsigneNotify: true, // CARGO-47047 收发通大小写控制
      isUppercaseByConfig: true // CARGO-49117 是否大写
    }
  },
  computed: {
    readonly() {
      if (!this.cooperateEdit) return true
      return this.action === 'look'
    },
    isEdit() {
      if (!this.cooperateEdit) return false
      return this.action !== 'look'
    },
    officeList() {
      return this.context.officeList
    },
    config() {
      return this.context.config
    },
    currentOfficeId() {
      return this.$store.getters.currentOfficeId
    },
    visibleDesignationAgent() {
      return this.job && (this.job.cargoSource === 'NC' || !this.job.cargoSource)
    },
    cacheOffices() {
      if (this.isRegionalCommission) {
        return getBranchByLevel(this.job.opOffice)
      } else {
        return null
      }
    },
    // 销售分公司
    salesOffice() {
      return this.job.salesOffice
    }
  },
  watch: {
  },
  beforeCreate() {
  },
  async created() {
    this.notUppercaseShipperConsigneNotify = await JobUtils.uppercaseShipperConsigneNotify(this.context.config)
    this.isHC = String(this.context.config.get('ToExoSystem')) === 'HC'
    this.isShowContactPersonDetail = String(this.context.config.get('ToExoSystem')) === 'HC'
    this.isUppercaseByConfig = Number(this.context.config.get('autoUppercaseEnabled')) === 0 // CARGO-49117 英文品名、唛头可以支持小写字 为0就大写 1可以大写可以小写
  },
  beforeMount() {
  },
  methods: {
    setJobSelectValue(obj) {
      this.job[obj.key] = obj.value
    },
    async onShow(row, isRefresh) {
      if (!isRefresh) {
        return
      }
      for (const key in this.userPortRoleData) {
        this.userPortRoleData[key] = null
      }
      this.job = row
      if (!this.job.uuid) { // 新增时，默认生成cargoDoc
        const hdoc = await new SeaImportJob(row).getMainHbl(true)
        const mdoc = await new SeaImportJob(row).getMainMbl(true)
        this.job.seaCargoDoc = []
        this.job.seaCargoDoc.push(hdoc)
        this.job.seaCargoDoc.push(mdoc)
      }
      // 当小票加入主票后，要显示主票的单号
      if (this.job.lclMasterUuid && !this.job.masterJobNo) {
        this.job.masterJobNo = this.job.lclMaster ? this.job.lclMaster.jobNo : ''
      }
      this.pm.fillView()
      if (this.action === 'copy' && this.job.seaEQ && this.job.seaEQ.length > 0) {
        ContainerUtil.autoJustContainerUsages(this.job, 'copy')
      }
      OverseaCustomerUtils.loadOverseaAgentChanged(this)
      if (!this.isEdit && this.job.poNo && this.needConfirmProjectNo) {
        this.poNoRed = await checkPoNoIsExist(this.job.poNo, this.job.uuid).then(res => res.data) > 0
      }
      JobUtils.loadCompanyCargoSales(this, this.job, this.pm.isSpecifiedSalesBusiness)
    },
    async getSubmitData() {
      await this.pm.validateForm()
      await this.pm.fillModel()
      const job = { ...this.job }
      return {
        job,
        seaCargoDoc: this.job.seaCargoDoc,
        seaEQ: this.seaEqList,
        delseaEQUuids: this.job.delseaEQUuids,
        containers: this.job.containers,
        delContainerUuids: this.job.delContainerUuids,
        delContainerUsageUuids: this.job.delContainerUsageUuids
      }
    },
    // tab页签结束后的处理
    endTabHandler() {},
    async onExcerptionChangeFunc(data) {
      this.job.shipperCode = data.shipperCode
      this.job.shipperLine1 = data.shipperLine1
      this.job.shipperLine2 = data.shipperLine2
      this.job.shipperLine3 = data.shipperLine3
      this.job.shipperLine4 = data.shipperLine4
      this.job.shipperLine5 = data.shipperLine5
      this.job.shipperLine6 = data.shipperLine6
      this.job.shipperLine7 = data.shipperLine7

      this.job.consigneeCode = data.consigneeCode
      this.job.consigneeLine1 = data.consigneeLine1
      this.job.consigneeLine2 = data.consigneeLine2
      this.job.consigneeLine3 = data.consigneeLine3
      this.job.consigneeLine4 = data.consigneeLine4
      this.job.consigneeLine5 = data.consigneeLine5
      this.job.consigneeLine6 = data.consigneeLine6
      this.job.consigneeLine7 = data.consigneeLine7

      this.job.notifyCode = data.notifyCode
      this.job.notifyLine1 = data.notifyLine1
      this.job.notifyLine2 = data.notifyLine2
      this.job.notifyLine3 = data.notifyLine3
      this.job.notifyLine4 = data.notifyLine4
      this.job.notifyLine5 = data.notifyLine5
      this.job.notifyLine6 = data.notifyLine6
      this.job.notifyLine7 = data.notifyLine7

      const hDoc = await new SeaImportJob(this.job).getMainHbl(true)
      if (hDoc) {
        hDoc.shipperCode = this.job.shipperCode
        hDoc.consigneeCode = this.job.consigneeCode
        hDoc.notifyCode = this.job.notifyCode

        hDoc.shipperLine1 = data.shipperLine1
        hDoc.shipperLine2 = data.shipperLine2
        hDoc.shipperLine3 = data.shipperLine3
        hDoc.shipperLine4 = data.shipperLine4
        hDoc.shipperLine5 = data.shipperLine5
        hDoc.shipperLine6 = data.shipperLine6
        hDoc.shipperLine7 = data.shipperLine7

        hDoc.consigneeLine1 = data.consigneeLine1
        hDoc.consigneeLine2 = data.consigneeLine2
        hDoc.consigneeLine3 = data.consigneeLine3
        hDoc.consigneeLine4 = data.consigneeLine4
        hDoc.consigneeLine5 = data.consigneeLine5
        hDoc.consigneeLine6 = data.consigneeLine6
        hDoc.consigneeLine7 = data.consigneeLine7

        hDoc.notifyLine1 = data.notifyLine1
        hDoc.notifyLine2 = data.notifyLine2
        hDoc.notifyLine3 = data.notifyLine3
        hDoc.notifyLine4 = data.notifyLine4
        hDoc.notifyLine5 = data.notifyLine5
        hDoc.notifyLine6 = data.notifyLine6
        hDoc.notifyLine7 = data.notifyLine7
      }
    },
    /**
     * 单号抄录
     */
    onExcerption() {
      this.importPromptTitleDialog.visible = true
    },
    /**
     * @public
     * 代码检索
     */
    onCodeSearch() {
      this.billAddressDialog.visible = true
    },
    codeSearchCallback(data) {
      let billAddress = null
      if (data.shipperInfo) {
        billAddress = data.shipperInfo
        let fromIndex = 0
        let i = 1
        for (; i < 6; ++i) {
          const index = billAddress.indexOf('\n', fromIndex)
          if (index === -1) {
            break
          }
          this.job['shipperLine' + i] = billAddress.substring(fromIndex, index)
          fromIndex = index + 1
        }
        this.job['shipperLine' + i] = billAddress.substring(fromIndex)

        this.job.shipperCode = data.shipperCode

        this.shipperAddrChangeFunc(data.shipperInfo)
      }
      if (data.consigneeInfo) {
        billAddress = data.consigneeInfo
        let fromIndex = 0
        let i = 1
        for (; i < 5; ++i) {
          const index = billAddress.indexOf('\n', fromIndex)
          if (index === -1) {
            break
          }
          this.job['consigneeLine' + i] = billAddress.substring(fromIndex, index)
          fromIndex = index + 1
        }
        this.job['consigneeLine' + i] = billAddress.substring(fromIndex)
        this.job.consigneeCode = data.consigneeCode
        this.consigneeAddrChangeFunc(data.consigneeInfo)
      }
      if (data.notifyInfo) {
        billAddress = data.notifyInfo
        let fromIndex = 0
        let i = 1
        for (; i < 5; ++i) {
          const index = billAddress.indexOf('\n', fromIndex)
          if (index === -1) {
            break
          }
          this.job['notifyLine' + i] = billAddress.substring(fromIndex, index)
          fromIndex = index + 1
        }
        this.job['notifyLine' + i] = billAddress.substring(fromIndex)
        this.job.notifyCode = data.notifyCode
        this.notifyChangeFunc(data.notifyInfo)
      }
    },
    /**
     * 收货人选择
     */
    async consigneeAddrChangeFunc() {
      const hdoc = await new SeaImportJob(this.job).getMainHbl(true)
      if (hdoc) {
        hdoc.consigneeCode = this.job.consigneeCode
        hdoc.consigneeLine1 = this.job.consigneeLine1
        hdoc.consigneeLine2 = this.job.consigneeLine2
        hdoc.consigneeLine3 = this.job.consigneeLine3
        hdoc.consigneeLine4 = this.job.consigneeLine4
        hdoc.consigneeLine5 = this.job.consigneeLine5
        hdoc.consigneeLine6 = this.job.consigneeLine6
      }
    },
    /**
     * 通知人选择
     */
    async notifyChangeFunc() {
      const hdoc = await new SeaImportJob(this.job).getMainHbl(true)
      if (hdoc) {
        hdoc.notifyCode = this.job.notifyCode
        hdoc.notifyLine1 = this.job.notifyLine1
        hdoc.notifyLine2 = this.job.notifyLine2
        hdoc.notifyLine3 = this.job.notifyLine3
        hdoc.notifyLine4 = this.job.notifyLine4
        hdoc.notifyLine5 = this.job.notifyLine5
        hdoc.notifyLine6 = this.job.notifyLine6
      }
    },
    async shipperAddrChangeFunc() {
      const hdoc = await new SeaImportJob(this.job).getMainHbl(true)
      if (hdoc) {
        hdoc.shipperCode = this.job.shipperCode
        hdoc.shipperLine1 = this.job.shipperLine1
        hdoc.shipperLine2 = this.job.shipperLine2
        hdoc.shipperLine3 = this.job.shipperLine3
        hdoc.shipperLine4 = this.job.shipperLine4
        hdoc.shipperLine5 = this.job.shipperLine5
        hdoc.shipperLine6 = this.job.shipperLine6
      }
    },
    // 组装打印参数
    getPrintData() {
      const params = {}
      params.category = 'SIJOBNO'
      params.ctx = new SeaImportJob(this.job)
      params.JOB_UUID = this.job.uuid
      params.jobuuid = this.job.uuid
      this.$logger.log('params', params)
      return params
    },
    opOfficeChargeHandler() {
      JobUtils.opOfficeChange({ view: this, job: this.job })
    },
    onCarrierIdChange() {
      JobUtils.matchUserPortConfig(this, this.job)
      JobUtils.matchRegionWarehouseMappingConfig(this.job)
    },
    onCustomJobTypeChange() {
      JobUtils.matchUserPortConfig(this, this.job)
      JobUtils.matchRegionWarehouseMappingConfig(this.job)
    },
    // 设置操作分公司
    setOpOffice(val) {
      this.job.opOffice = val
    },
    onCargoTypeChagne() {
      JobUtils.matchUserPortConfig(this, this.job)
    },
    loadVoyageFlight() {
      const judgmentOfSeaImportVoyageNo = Number(this.config.get('JudgmentOfSeaImportVoyageNo')) === 1
      if (judgmentOfSeaImportVoyageNo && !this.job.voyageFlight) {
        this.job.voyageFlight = 'V.'
      }
    }
  }
}
</script>

<style scoped lang="scss">
#app .prediction-basic-from {
  .form-column {
    width: auto;
  }
}
.required .el-form-item__label {
  color: #1F75D5!important
}
.poNoClass {
  /deep/ .el-input.is-disabled .el-input__inner {
    color: red !important;
  }
}
</style>
